import React from 'react';
import { IPopoverProps, Popover } from '@synerg/vdl-react-components';

export interface IMDFPopoverProps extends IPopoverProps {
  containerClassName?: string;
  // Accessibility: this id links the popover to the corresponding page element.
  errorId?: string;
}

export class MDFPopover extends React.Component<IMDFPopoverProps, any> {
  render() {
    const { className, children, errorId, id, ...customProps } = this.props;
    let renderClassName = className;
    const { containerClassName, ...popoverProps } = { ...customProps };

    renderClassName = 'mdf ' + (renderClassName || '');

    // The popover gets the property from its parent and the className gets overridden,
    // adding containerClassName to accept custom Styles and passing it over to the popover Component.
    renderClassName = customProps.containerClassName ? `${renderClassName} ${customProps.containerClassName} ` : renderClassName;

    return <Popover className={renderClassName} id={errorId || id} {...popoverProps}>{children}</Popover>;
  }
}
